import { render, staticRenderFns } from "./PaymentMethodSelector.vue?vue&type=template&id=0d36e769&scoped=true"
import script from "./PaymentMethodSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/payment/payment-method-selector.scss?vue&type=style&index=0&id=0d36e769&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d36e769",
  null
  
)

export default component.exports